// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fullDivAssetsManager
{
    
    background-color: #181818;
    width: 100%;
    height: 95%;
    border-radius: 6px;
    overflow-y:  scroll;
    overflow-x: hidden;
    border-width: 2px;
    border-style: solid;
    border-color: transparent;
}

.ASsetItemDisplayTypeAll
{
    display: inline-block;
}

.ASsetItemDisplayTypeImage
{
    vertical-align: middle;
    background-color:var(--default-icon-color);
    border-radius: 4px;
    padding: 1px;
    
}

.ASsetItemDisplayType
{
    background-color: var(--default-icon-color);
    color: black;
    border-radius: 3px;
    font-size: 11px;
    font-weight: bold;
    padding-left: 3px;
    padding-right: 3px;
    line-height: 30px;
    vertical-align: middle;
    

}

.AssetSectionTitle
{
    background-color: #404040;
    margin: 5px;
    width: calc(100%-10px);
    color: #A0A0A0;
    border-radius: 4px;
    padding-left: 4px;
    font-size: small;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
}

.assetSectionItemSelected
{
    font-size: smaller;
    border-radius: 3px;
    border-width: 1px;
    border-style: solid;
    border-color: var(--default-icon-color);

}
.AssetSectionItem
{
    background-color: transparent;
    margin: 5px;
    width: 96%;
    
    
    font-size: small;
    line-height: 1.3;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
}

.AssetSectionItemDateSpan
{
    margin-top: 0px;
    color:white;
    background-color: black;
    border-style: solid;
    border-color: var(--default-icon-color);
    border-width: 1px;
    border-radius: 3px;
    font-size: smaller;
    padding-left: 6px;
    padding-right: 6px;
    line-height: 1.6;
}

.AssetSectionItemError
{
    margin-top: 0px;
    color:white;
    background-color: red;
    border-style: solid;
    border-color: var(--default-icon-color);
    border-width: 1px;
    border-radius: 3px;
    font-size: smaller;
    padding-left: 6px;
    padding-right: 6px;
    line-height: 1.6;
}


.AssetSectionItemVideoSpan
{
    margin-top: 0px;
    color:white;
    background-color: black;
    border-style: solid;
    border-color: var(--default-icon-color);
    border-width: 1px;
    border-radius: 3px;
    font-size: smaller;
    padding-left: 6px;
    padding-right: 6px;
    line-height: 1.6;
}


.AssetSectionSubItem
{
    background-color: transparent;
    margin: 5px;
    width: 96%;
    font-size:smaller;
    line-height: 1;
    padding-left: 20px;
    text-align: left;
    overflow: hidden;
    color:gray;
    white-space: nowrap;
}

.AssetSectionSubItemVideo
{
    background-color: transparent;
    margin: 5px;
    width: 96%;
    font-size:smaller;
    line-height: 1;
    padding-left: 30px;
    text-align: left;
    overflow: hidden;
    color:gray;
    white-space: nowrap;
}




.fullDivAssetsManager::-webkit-scrollbar{
    display: none;
}



.fullDivAssetsManager::-webkit-scrollbar-track {
    background: #101010; /* color of the tracking area */
  }
  
.fullDivAssetsManager::-webkit-scrollbar-thumb {
    background-color: #151515; /* color of the scroll thumb */
    border-radius: 20px; /* roundness of the scroll thumb */
    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */
  }

.fullDivAssetsManager::-webkit-scrollbar{
    width:12px;
}

.assetpb1
{
    width: 100px;
    background-color: #404040; 
    mix-blend-mode: difference;
    border-radius: 4px; 
    overflow: hidden; 
    color:white;
    height: 17px;
}
.assetpb2
{
    margin-top: 4px;
    margin-bottom: 4px;
    margin-left: 4px;
    margin-right: 4px;
    border-radius: 2px; 

    font-size: 9px;   
    color:white;
    text-align: center;
    height: 9px; 
    background-color: var(--default-icon-color);
}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/assetsmanager/assetsmanager.css"],"names":[],"mappings":"AAAA;;;IAGI,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,sBAAsB;IACtB,0CAA0C;IAC1C,kBAAkB;IAClB,YAAY;;AAEhB;;AAEA;;IAEI,2CAA2C;IAC3C,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;;;AAG1B;;AAEA;;IAEI,yBAAyB;IACzB,WAAW;IACX,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,uCAAuC;;AAE3C;AACA;;IAEI,6BAA6B;IAC7B,WAAW;IACX,UAAU;;;IAGV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,uCAAuC;IACvC,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,uCAAuC;IACvC,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;;IAEI,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,uCAAuC;IACvC,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;;IAEI,6BAA6B;IAC7B,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;AAEA;;IAEI,6BAA6B;IAC7B,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;;;;AAKA;IACI,aAAa;AACjB;;;;AAIA;IACI,mBAAmB,EAAE,+BAA+B;EACtD;;AAEF;IACI,yBAAyB,EAAE,8BAA8B;IACzD,mBAAmB,EAAE,kCAAkC;IACvD,2CAA2C,EAAE,wCAAwC;EACvF;;AAEF;IACI,UAAU;AACd;;AAEA;;IAEI,YAAY;IACZ,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;AACA;;IAEI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;;IAElB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,2CAA2C;AAC/C","sourcesContent":[".fullDivAssetsManager\n{\n    \n    background-color: #181818;\n    width: 100%;\n    height: 95%;\n    border-radius: 6px;\n    overflow-y:  scroll;\n    overflow-x: hidden;\n    border-width: 2px;\n    border-style: solid;\n    border-color: transparent;\n}\n\n.ASsetItemDisplayTypeAll\n{\n    display: inline-block;\n}\n\n.ASsetItemDisplayTypeImage\n{\n    vertical-align: middle;\n    background-color:var(--default-icon-color);\n    border-radius: 4px;\n    padding: 1px;\n    \n}\n\n.ASsetItemDisplayType\n{\n    background-color: var(--default-icon-color);\n    color: black;\n    border-radius: 3px;\n    font-size: 11px;\n    font-weight: bold;\n    padding-left: 3px;\n    padding-right: 3px;\n    line-height: 30px;\n    vertical-align: middle;\n    \n\n}\n\n.AssetSectionTitle\n{\n    background-color: #404040;\n    margin: 5px;\n    width: calc(100%-10px);\n    color: #A0A0A0;\n    border-radius: 4px;\n    padding-left: 4px;\n    font-size: small;\n    text-align: left;\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n.assetSectionItemSelected\n{\n    font-size: smaller;\n    border-radius: 3px;\n    border-width: 1px;\n    border-style: solid;\n    border-color: var(--default-icon-color);\n\n}\n.AssetSectionItem\n{\n    background-color: transparent;\n    margin: 5px;\n    width: 96%;\n    \n    \n    font-size: small;\n    line-height: 1.3;\n    text-align: left;\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n.AssetSectionItemDateSpan\n{\n    margin-top: 0px;\n    color:white;\n    background-color: black;\n    border-style: solid;\n    border-color: var(--default-icon-color);\n    border-width: 1px;\n    border-radius: 3px;\n    font-size: smaller;\n    padding-left: 6px;\n    padding-right: 6px;\n    line-height: 1.6;\n}\n\n.AssetSectionItemError\n{\n    margin-top: 0px;\n    color:white;\n    background-color: red;\n    border-style: solid;\n    border-color: var(--default-icon-color);\n    border-width: 1px;\n    border-radius: 3px;\n    font-size: smaller;\n    padding-left: 6px;\n    padding-right: 6px;\n    line-height: 1.6;\n}\n\n\n.AssetSectionItemVideoSpan\n{\n    margin-top: 0px;\n    color:white;\n    background-color: black;\n    border-style: solid;\n    border-color: var(--default-icon-color);\n    border-width: 1px;\n    border-radius: 3px;\n    font-size: smaller;\n    padding-left: 6px;\n    padding-right: 6px;\n    line-height: 1.6;\n}\n\n\n.AssetSectionSubItem\n{\n    background-color: transparent;\n    margin: 5px;\n    width: 96%;\n    font-size:smaller;\n    line-height: 1;\n    padding-left: 20px;\n    text-align: left;\n    overflow: hidden;\n    color:gray;\n    white-space: nowrap;\n}\n\n.AssetSectionSubItemVideo\n{\n    background-color: transparent;\n    margin: 5px;\n    width: 96%;\n    font-size:smaller;\n    line-height: 1;\n    padding-left: 30px;\n    text-align: left;\n    overflow: hidden;\n    color:gray;\n    white-space: nowrap;\n}\n\n\n\n\n.fullDivAssetsManager::-webkit-scrollbar{\n    display: none;\n}\n\n\n\n.fullDivAssetsManager::-webkit-scrollbar-track {\n    background: #101010; /* color of the tracking area */\n  }\n  \n.fullDivAssetsManager::-webkit-scrollbar-thumb {\n    background-color: #151515; /* color of the scroll thumb */\n    border-radius: 20px; /* roundness of the scroll thumb */\n    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */\n  }\n\n.fullDivAssetsManager::-webkit-scrollbar{\n    width:12px;\n}\n\n.assetpb1\n{\n    width: 100px;\n    background-color: #404040; \n    mix-blend-mode: difference;\n    border-radius: 4px; \n    overflow: hidden; \n    color:white;\n    height: 17px;\n}\n.assetpb2\n{\n    margin-top: 4px;\n    margin-bottom: 4px;\n    margin-left: 4px;\n    margin-right: 4px;\n    border-radius: 2px; \n\n    font-size: 9px;   \n    color:white;\n    text-align: center;\n    height: 9px; \n    background-color: var(--default-icon-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
